import React from 'react';

const EventName = ({event}) => (
    <h4 className="sr-gray-1400 flex-1">{event.name}</h4>
);

export default EventName;
